<template>
  <div class="container mol-typical-page-container-20 text-center">

    <h4 class="title-text"><img :src="`${$imagePathS3}products/family-membership-icon.svg`" alt="Logo"> Family Membership Invite</h4>


    <!--    loading -->
    <LoadingSpinner v-if="initializing"></LoadingSpinner>


    <!--    some error -->
    <div v-else-if="errorMessage" class="invite-error-message">
      <p>{{errorMessage}}</p>
      <SignIn v-if="!userStore.isLoggedIn()" @user-updated="attemptJoin()"></SignIn>
    </div>

    <!--    you've successfully joined the family plan -->
    <div v-else>

    </div>


  </div>
</template>


<script>
import axios from "axios";
import {userStore} from "@/userStore";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import SignIn from "@/components/auth/SignIn.vue";


export default {
  name: "FamilyMembershipJoinPage",
  components: {SignIn, LoadingSpinner},
  props: ['subscription_id', 'invite_code'],
  data() {
    return {
      initializing: true,
      errorMessage: null,
    }
  },

  computed: {
    userStore() {
      return userStore;
    }
  },

  async created() {
    return this.attemptJoin();
  },

  methods: {
    async attemptJoin() {

      try {
        const response = await axios.post(`/api/membership/family-plan/join`, {
          subscription_id: this.subscription_id,
          invite_code: this.invite_code
        }, {
          validateStatus: status => status < 500 // we want to handle the 400s deliberately
        });

        //console.log(`/family-plan/join`, response);

        if ( response.status >= 400 ) {
          this.errorMessage = response.data?.message || 'invite error';
        }
        else {
          // success
          userStore.setUser(response.data);
          this.$router.push({name: 'MembershipPage'});
        }
      } catch (err) {
        console.log(err);
      }
      this.initializing = false;
    }
  }
}
</script>


<style scoped>

.title-text {
  color: var(--mol-color-gold-text);

  img {
    height: 1.35em;
    vertical-align: text-bottom;
  }
}

.invite-error-message {
  color: var(--mol-color-gold-text);
}


</style>